<script lang="ts">
    let {
        name,
        type = "text",
        error = undefined,
        value = $bindable(),
        placeholder = ""
    }: {
        name: string,
        type?: string,
        error?: string,
        value: string | number,
        placeholder: string,
    } = $props();
</script>

{#if type == "textarea" && typeof value == "string"}
    <textarea name="{name}" class="form-control" contenteditable="true" bind:textContent={value}></textarea>
{:else}
    <input type="{type}" name="{name}" class="form-control" placeholder="{placeholder}" aria-label="{placeholder}" bind:value={value} />
{/if}
